(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"]) return;
  try {
    
  $('.faq-title .title').on('click', function () {
    $this = $(this).parent().next('.faq-content');
    $('.faq-content').not($this).slideUp();
    $this.slideToggle();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-masonry"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener("shopify:section:load", function(e){
    console.log("loaded")
    // init Masonry
    var $grid = $('.masonry-outer').packery({
      itemSelector: '.masonry-item',
      percentPosition: true
    });
    // layout Masonry after each image loads
    $grid.imagesLoaded().progress( function() {
      $grid.packery();
    });

    var videos = document.querySelectorAll('.masonry-outer video')
    for (var i = 0; i < videos.length; i++) {
      videos[i].addEventListener('loadedmetadata', function() {
        $grid.packery();
      })
    }
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-section-1-copy"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('shopify:section:load', function (e) {
      console.log('loaded');
      // init Masonry

      if (document.querySelector('.masonry-inner')) {
        var $grid = $('.masonry-inner').packery({
          itemSelector: '.masonry-item'
        });
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress(function () {
          $grid.packery();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-section-1"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('shopify:section:load', function (e) {
      console.log('loaded');
      // init Masonry

      if (document.querySelector('.masonry-inner')) {
        var $grid = $('.masonry-inner').packery({
          itemSelector: '.masonry-item'
        });
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress(function () {
          $grid.packery();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-section-2"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('shopify:section:load', function (e) {
      console.log('loaded');
      // init Masonry

      if (document.querySelector('.masonry-inner')) {
        var $grid = $('.masonry-inner').packery({
          itemSelector: '.masonry-item'
        });
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress(function () {
          $grid.packery();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-1"]) return;
  try {
    
  document.addEventListener('shopify:section:load', function (e) {
    console.log('loaded');
    // init Masonry
    var $grid = $('#masonry').packery({
      itemSelector: '.masonry-item'
    });
    // layout Masonry after each image loads
    $grid.imagesLoaded().progress(function () {
      $grid.packery();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
